import React, { useEffect, useRef, useState } from "react";
import { Alert, Button, Dialog, Divider, FormControlLabel, Menu, MenuItem, Radio, RadioGroup, Snackbar } from "@mui/material";
import axios from "axios";
import baseURL from "../../../configs/api";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import LocalSeeIcon from "@mui/icons-material/LocalSee";
import Webcam from "react-webcam";
import { useNavigate } from "react-router";
import useAuth from "../../../components/hooks/useAuth";
import { handleCapture } from "../../../utils/covertTheBase64FormatIntoImage";
import { branchTimezone } from "../../../utils/summaryCalculation";
import { delete_fileUpload, put_fileUpload } from "../../../services/appFileUpload";
import AddOfflinePayment from "./AddOfflinePayment2";
import { post_Payment, post_PaymentForValidateOutstandingBalance } from "../../../services/Payment";
import RefundSecurityDepositPopup from "./RefundSecurityDepositPopup2";
import useConfirm from "../../../components/hooks/useConfirm";
import ProcessPaymentBox from "./ProcessPaymentBox2";
import moment from "moment";
import CustomFormatDatePicker from "../../../components/common/CustomFormatDatePicker";
import { useTheme } from "../../../components/hooks/useTheme";
import PaymentDetailsPopup from "./PaymentDetailsPopup2";
import colorConfigs from "../../../configs/colorConfigs";
import PaymentRequest from "./PaymentRequest2";
import PaymentRequestDetails from "./PaymentRequestDetails2";
import { paymentRequestStatusColorCode } from "../../../utils/statusColorCode";
import { CustomImagePopup } from "../../../components/common/CustomImagePopup";
import { donotValidateOutStandingBalance, isReOpen, recalculateAtReturn, updateFilesAndCommentsApi } from "../../../services/rental";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";
import useAccessControl from "../../../components/hooks/useAccessControl";
import useGeneral from "../../../components/hooks/useGeneral";
import { format } from "date-fns";


type CheckinProps = {
  goToNextPage: (page: number) => void;
  allPaymentList: any[];
  summaryData: any;
  formattedCreatedAt: string;
  isCompletedOrCancelled: boolean;
  returnLocationOptions: any[];
  bookedVehicleData: any | null;
  checkInFiles: any[];
  vehicleReplacementCheckInFiles: any[];
  reservationId: number;
  securityDepositAmount: number;
  refundList: any[];
  preferredDateFormat: string;
  creditCardList: any[];
  allPaymentRequestList: any[];
  refreshTheSummary: () => void;
  refreshThepayment: () => void;
  refreshThePaymentRequest: () => void;
  refreshThRefund: () => void;
  refreshTheAttachement: () => void;
  setPleaseWaitPopup: (value: boolean) => void;
};

export const Checkin = ({
  goToNextPage,
  allPaymentList,
  summaryData,
  formattedCreatedAt,
  isCompletedOrCancelled,
  returnLocationOptions,
  bookedVehicleData,
  checkInFiles,
  vehicleReplacementCheckInFiles,
  reservationId,
  securityDepositAmount,
  refundList,
  preferredDateFormat,
  creditCardList,
  allPaymentRequestList,
  refreshTheSummary,
  refreshThepayment,
  refreshThePaymentRequest,
  refreshThRefund,
  refreshTheAttachement,
  setPleaseWaitPopup
}: CheckinProps) => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { dateFormat }: any = useGeneral();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const { permissions }: any = useAccessControl();
  const [isContinue, setIsContinue] = useState<boolean>(false);
  const [processPaymentBox, setProcessPaymentBox] = useState<boolean>(false);
  const [showWebcam, setShowWebcam] = useState<boolean>(false);
  const [filePath, setFilePath] = useState<any[]>([]);
  const [fileIndex, setFileIndex] = useState<number>(-1);
  const [imagePopup, setImagePopup] = useState<boolean>(false);
  const [fuelLevelAtCheckIn, setFuelLevelAtCheckIn] = useState<number>(0);
  const [odometerAtCheckIn, setOdometerAtCheckIn] = useState<string>("");
  const [odometerShowSpan, setOdometerShowSpan] = useState<boolean>(false);
  const [fuelLevelAtCheckOut, setFuelLevelCheckOut] = useState<string>("0");
  const [odometerAtCheckOut, setOdometerAtCheckOut] = useState<string>("");
  const [returnLocations, setReturnLocations] = useState<number>(0);
  const [isChargeFuelToClient, setIsChargeFuelToClient] = useState<boolean>(false);
  const [recalculateRatesOnEarlReturn, setRecalculateRatesOnEarlyReturn] = useState<boolean>(false);

  const [returnDates, setReturnDates] = useState<string>("");
  const [returnTimes, setReturnTimes] = useState<string>("");

  const [refundSecurityDepositPopup, setRefundSecurityDepositPopup] = useState<boolean>(false);

  const [offlinePaymentPopup, setOfflinePaymentPopup] = useState<boolean>(false);
  const [isProcessPayment, setIsProcessPayment] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const [isSecurityDepositedPaid, setIsSecurityDepositedPaid] = useState<boolean>(false);
  const [isSecurityDepositedRefunded, setIsSecurityDepositedRefunded] = useState<boolean>(false);

  const [particularPaymentDetails, setParticularPaymentDetails] = useState<any | null>(null);
  const [openPaymentDetailsPopup, setOpenPaymentDetailsPopup] = useState<boolean>(false);

  const [isPaymentRequestType, setIsPaymentRequestType] = useState<boolean>(true);
  const [openPaymentRequestPopup, setOpenPaymentRequestPopup] = useState<boolean>(false);
  const [openPaymentRequestDetailsPopup, setOpenPaymentRequestDetailsPopup] = useState<boolean>(false);
  const [paymentRequestDetails, setPaymentRequestDetails] = useState<any | null>(null);
  const [showCopyPopup, setShowCopyPopup] = useState<boolean>(false);

  const formRef = useRef<HTMLFormElement | null>(null);

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!isCompletedOrCancelled) {
      setSAnchorEl(null)
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [sanchorEl, setSAnchorEl] = React.useState<null | HTMLElement>(null);
  const sopen = Boolean(sanchorEl);
  const shandleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!isCompletedOrCancelled) {
      setAnchorEl(null)
      setSAnchorEl(event.currentTarget);
    }
  };

  const shandleClose = () => {
    setSAnchorEl(null);
  };


  //Confirm Check In
  const [anchorE2, setAnchorE2] = useState<null | HTMLElement>(null);
  const open2 = Boolean(anchorE2);

  const handleClick2 = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!isCompletedOrCancelled) {
      setAnchorE2(event.currentTarget);
    }
  };

  const handleClose2 = () => {
    setAnchorE2(null);
  };

  const UpdateTimezone = branchTimezone(formattedCreatedAt);

  useEffect(() => {
    if (summaryData?.isVehicleReplaced) {
      const checkinOldFiles = vehicleReplacementCheckInFiles?.filter((item: any) =>
        parseInt(item?.tabName?.replace("Checkin-VehicleReplacement-", "")) === summaryData?.id
      );

      setFilePath(
        checkinOldFiles?.map((item: any) => ({
          id: item.id,
          fileName: `${baseURL}reservationFile/Get?name=${item.fileName}`
        }))
      );
    } else {
      setFilePath(
        checkInFiles?.map((item: any) => ({
          id: item.id,
          fileName: `${baseURL}reservationFile/Get?name=${item.fileName}`
        }))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkInFiles, vehicleReplacementCheckInFiles, summaryData])

  useEffect(() => {
    if (parseInt(odometerAtCheckIn) < Number(odometerAtCheckOut)) {
      setOdometerShowSpan(true);
    } else {
      setOdometerShowSpan(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [odometerAtCheckIn]);

  useEffect(() => {
    const currentDate = new Date(UpdateTimezone);

    if (summaryData) {
      setOdometerAtCheckIn(summaryData?.odometerAtCheckIn || "");
      setFuelLevelAtCheckIn(summaryData?.fuelLevelAtCheckIn);
      setReturnLocations(summaryData?.returenLoationId);
      setOdometerAtCheckOut(summaryData?.odometerAtCheckOut);
      setFuelLevelCheckOut(summaryData?.fuelLevelAtCheckOut);
      setIsChargeFuelToClient(summaryData?.chargeFuelToClient);
      setRecalculateRatesOnEarlyReturn(summaryData?.recalculateRatesOnEarlyReturn);

      if (summaryData?.dateTimeCheckIn) {
        setReturnDates(summaryData?.dateTimeCheckIn?.split("T")[0]);
        setReturnTimes(summaryData?.dateTimeCheckIn?.split("T")[1]);
      } else {
        setReturnDates(moment(currentDate).format("YYYY-MM-DD"));
        setReturnTimes(format(currentDate, "kk:mm"));
      }

      setIsSecurityDepositedPaid(summaryData?.securityDepositPaid);
      setIsSecurityDepositedRefunded(summaryData?.securityDepositRefunded);
    }

    setIsContinue(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [summaryData]);

  const webRef = useRef(null);
  const inputFileRef = useRef<HTMLInputElement>(null);
  const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPleaseWaitPopup(true);
    const selectedFiles = e.target.files as FileList;

    if (selectedFiles.length !== 0) {
      const formData = new FormData();
      formData.append("ImageFile", selectedFiles[0]);

      axios
        .post(`${baseURL}reservationFile/upload`, formData, {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "multipart/form-data"
          },
          withCredentials: true,
        })
        .then((response) => {
          let files: any[] = [];

          if (summaryData?.isVehicleReplaced) {
            files.push({
              attributeName: "Reservation",
              attributeId: reservationId,
              fileName: response.data,
              tabName: `Checkin-VehicleReplacement-${summaryData?.id}`,
              userId: auth?.id ?? 0,
              createdDate: new Date(UpdateTimezone).toLocaleString()
            });
          } else {
            files.push({
              attributeName: "Reservation",
              attributeId: reservationId,
              fileName: response.data,
              tabName: "Checkin",
              userId: auth?.id ?? 0,
              createdDate: new Date(UpdateTimezone).toLocaleString()
            });
          }

          uploadTheFiles(files);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      setPleaseWaitPopup(false);
    }
  };

  const updateFile = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {
    if (!isCompletedOrCancelled) {
      setPleaseWaitPopup(true);
      const selectedFiles = e.target.files as FileList;
      if (selectedFiles.length !== 0) {
        const formData = new FormData();
        formData.append("ImageFile", selectedFiles[0]);
        axios
          .post(`${baseURL}reservationFile/upload`, formData, {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "multipart/form-data"
            },
            withCredentials: true,
          })
          .then((response) => {

            put_fileUpload({
              id,
              attributeName: "Reservation",
              attributeId: reservationId,
              fileName: response.data,
              tabName: summaryData?.isVehicleReplaced ? `Checkin-VehicleReplacement-${summaryData?.id}` : "Checkin",
              userId: auth?.id ?? 0,
              createdDate: new Date(UpdateTimezone).toLocaleString()
            }, auth?.id, tenantId)
              .then((_) => {
                setFilePath((prevPath: any[]) =>
                  prevPath.map(file =>
                    file.id === id ? {
                      ...file, filename: `${baseURL}reservationFile/Get?name=` +
                        response.data,
                    } : file
                  )
                );
                setPleaseWaitPopup(false);
                handleTenantError(null);
              })
              .catch((error) => {
                const errorMessage = error?.response?.data?.message || error?.message || "File upload failed.";
                setConfirmData({
                  title: 'Warning',
                  summary: errorMessage,
                  confirmBtn: 'Ok',
                  isConfirm: (callback: any) => {
                    callback();
                  }
                });
                setConfirmPopup(true);
                setPleaseWaitPopup(false);
                handleTenantError(error);
              })
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });
      } else {
        setPleaseWaitPopup(false);
      }
    }
  }

  const reCalculateTheRate = () => {
    if (formRef.current) {
      if (formRef?.current?.checkValidity()) {
        formRef?.current?.requestSubmit();
      } else {
        formRef?.current?.reportValidity();
        return;
      }
    }

    const dateTimeCheckOut = summaryData?.dateTimeCheckOut;
    if (!dateTimeCheckOut) {
      setConfirmData({
        title: 'Warning',
        summary: "Checkout date is invalid.",
        confirmBtn: 'Ok',
        isConfirm: async (callback: any) => {
          callback();
        }
      });
      setConfirmPopup(true);
      return;
    }
    const checkOutDate = new Date(dateTimeCheckOut)?.toISOString();

    if (returnDates === "" || returnTimes === "") {
      setConfirmData({
        title: 'Warning',
        summary: "Return date and time are required.",
        confirmBtn: 'Ok',
        isConfirm: async (callback: any) => {
          callback();
        }
      });
      setConfirmPopup(true);
      return;
    }

    const returnDateTime = new Date(`${returnDates}T${returnTimes}`)?.toISOString();
    if (returnDateTime < checkOutDate) {
      setConfirmData({
        title: 'Warning',
        summary: "Return date and time cannot be earlier than or the same as check-out date.",
        confirmBtn: 'Ok',
        isConfirm: async (callback: any) => {
          callback();
        }
      });
      setConfirmPopup(true);
      return;
    }

    if (odometerAtCheckIn !== undefined && odometerAtCheckOut !== undefined) {
      if (odometerAtCheckIn < odometerAtCheckOut) {
        setConfirmData({
          title: 'Warning',
          summary: "Odometer reading at check-in must be greater than check-out reading.",
          confirmBtn: 'Ok',
          isConfirm: async (callback: any) => {
            callback();
          }
        });
        setConfirmPopup(true);
        return;
      }
    } else {
      setConfirmData({
        title: 'Warning',
        summary: "Odometer readings are missing.",
        confirmBtn: 'Ok',
        isConfirm: async (callback: any) => {
          callback();
        }
      });
      setConfirmPopup(true);
      return;
    }

    if (!isCompletedOrCancelled) {
      setPleaseWaitPopup(true);

      recalculateAtReturn(
        {
          returnLocationId: returnLocations,
          fuelLevel: fuelLevelAtCheckIn,
          isChargeFuelToClient: isChargeFuelToClient,
          odometer: odometerAtCheckIn,
          returnDate: returnDates + "T" + returnTimes,
          isRecalculateRatesOnEarlyReturn: recalculateRatesOnEarlReturn,
          fileUploadDataDtos: []
        },
        reservationId,
        auth?.id,
        tenantId
      )
        .then(() => {
          refreshTheSummary();
          handleTenantError(null);
        })
        .catch(error => {
          setPleaseWaitPopup(false);
          setConfirmData({
            title: 'Warning',
            summary: error.response.data,
            confirmBtn: 'Ok',
            isConfirm: (callback: any) => {
              callback();
            }
          });

          setConfirmPopup(true);
          handleTenantError(error);
        })
    }
  }

  const showWarningMessageOnNoImage = (cb: any) => {
    setConfirmData({
      title: 'Confirm Check In',
      summary: 'Are you sure you want to continue without image?',
      confirmBtn: 'Continue without image',
      isConfirm: (callback: any) => {
        callback();
        setIsContinue(true);
        cb();
      }
    });

    setConfirmPopup(true);
  }

  const handleSubmit = async (isValidate: boolean) => {
    if (formRef?.current) {
      if (formRef?.current?.checkValidity()) {
        formRef?.current?.requestSubmit();
      } else {
        setTimeout(() => formRef?.current?.reportValidity(), 0);
        return;
      }
    }

    if (!isCompletedOrCancelled) {
      if (!isContinue && filePath?.length <= 0) {
        showWarningMessageOnNoImage(() => {
          confirmCheckIn(isValidate);
        });
        return;
      }

      confirmCheckIn(isValidate);
    }
  }

  const confirmCheckIn = (isValidate: boolean) => {
    const dateTimeCheckOut = summaryData?.dateTimeCheckOut;
    if (!dateTimeCheckOut) {
      setConfirmData({
        title: 'Warning',
        summary: "Checkout date is invalid",
        confirmBtn: 'Ok',
        isConfirm: async (callback: any) => {
          callback();
        }
      });
      setTimeout(() => setConfirmPopup(true), 0);
      return;
    }
    const checkOutDate = new Date(dateTimeCheckOut)?.getTime();
    if (returnDates === "" || returnTimes === "") {
      setConfirmData({
        title: 'Warning',
        summary: "Return date and time are required",
        confirmBtn: 'Ok',
        isConfirm: async (callback: any) => {
          callback();
        }
      });
      setTimeout(() => setConfirmPopup(true), 0);
      return;
    }

    const returnDateTime = new Date(`${returnDates}T${returnTimes}`)?.getTime();
    if (returnDateTime < checkOutDate) {
      setConfirmData({
        title: 'Warning',
        summary: "Return date and time cannot be earlier than or the same as check-out date.",
        confirmBtn: 'Ok',
        isConfirm: async (callback: any) => {
          callback();
        }
      });
      setTimeout(() => setConfirmPopup(true), 0);
      return;
    }

    if (odometerAtCheckIn !== undefined && odometerAtCheckOut !== undefined) {
      if (odometerAtCheckIn < odometerAtCheckOut) {
        setConfirmData({
          title: 'Warning',
          summary: "Odometer reading at check-in must be greater than check-out reading.",
          confirmBtn: 'Ok',
          isConfirm: async (callback: any) => {
            callback();
          }
        });
        setTimeout(() => setConfirmPopup(true), 0);
        return;
      }
    } else {
      setConfirmData({
        title: 'Warning',
        summary: "Odometer readings are missing.",
        confirmBtn: 'Ok',
        isConfirm: async (callback: any) => {
          callback();
        }
      });
      setTimeout(() => setConfirmPopup(true), 0);
      return;
    }

    setPleaseWaitPopup(true);
    submitOnConfirmCheckIn(isValidate);
  }

  const uploadTheFiles = (files: any[]) => {
    updateFilesAndCommentsApi(
      {
        fileUploadDatas: files,
        comments: []
      },
      reservationId,
      auth?.id,
      tenantId
    )
      .then(() => {
        setPleaseWaitPopup(false);
        refreshTheAttachement();
        handleTenantError(null);
      })
      .catch(error => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  }

  const submitOnConfirmCheckIn = (isValidate: boolean) => {
    if (!isCompletedOrCancelled) {
      if (isValidate) {
        post_PaymentForValidateOutstandingBalance(
          {
            returnLocationId: returnLocations,
            fuelLevel: fuelLevelAtCheckIn || 0,
            isChargeFuelToClient: isChargeFuelToClient,
            odometer: odometerAtCheckIn || 0,
            returnDate: returnDates + "T" + returnTimes,
            isRecalculateRatesOnEarlyReturn: recalculateRatesOnEarlReturn,
            fileUploadDataDtos: []
          },
          reservationId,
          auth?.id,
          tenantId
        )
          .then(() => {
            refreshTheSummary();
            refreshTheAttachement();
            goToNextPage(9);
            handleTenantError(null);
          })
          .catch(error => {
            setPleaseWaitPopup(false);
            refreshTheSummary();
            refreshTheAttachement();

            setConfirmData({
              title: 'Warning',
              summary: error.response.data,
              confirmBtn: 'Ok',
              isConfirm: (callback: any) => {
                callback();
              }
            });

            setConfirmPopup(true);
            handleTenantError(error);
          })
      } else {
        donotValidateOutStandingBalance(
          {
            returnLocationId: returnLocations,
            fuelLevel: fuelLevelAtCheckIn || 0,
            isChargeFuelToClient: isChargeFuelToClient,
            odometer: odometerAtCheckIn || 0,
            returnDate: returnDates + "T" + returnTimes,
            isRecalculateRatesOnEarlyReturn: recalculateRatesOnEarlReturn,
            fileUploadDataDtos: []
          },
          reservationId,
          auth?.id,
          tenantId
        )
          .then(() => {
            refreshTheSummary();
            refreshTheAttachement();
            goToNextPage(9);
            handleTenantError(null);
          })
          .catch(error => {
            setPleaseWaitPopup(false);
            setConfirmData({
              title: 'Warning',
              summary: error.response.data,
              confirmBtn: 'Ok',
              isConfirm: (callback: any) => {
                callback();
              }
            });

            setConfirmPopup(true);
            handleTenantError(error);
          })
      }
    }
  }

  const reopenedTheBooking = async () => {
    setConfirmData({
      title: 'Confirm Re-Open',
      summary: "Are you sure you want to change status to Re-Open?",
      confirmBtn: 'Yes',
      isConfirm: async (callback: any) => {
        setPleaseWaitPopup(true);

        isReOpen(
          reservationId,
          auth?.id,
          tenantId
        )
          .then(() => {
            refreshTheSummary();
            handleTenantError(null);
          })
          .catch(error => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          })

        callback();
      }
    });
    setConfirmPopup(true);
  };

  const handleAuthorize = async (isProcessPayment: boolean, id: number) => {
    if (!isCompletedOrCancelled) {
      setPleaseWaitPopup(true);

      let outstandingPayment = 0;
      outstandingPayment = summaryData?.outstandingBalance || 0;

      await post_Payment({
        reservationId: reservationId,
        paymentType: isProcessPayment ? "Payment" : "Security Deposit",
        paymentMethod: "Credit Card",
        dateofPayment: new Date(UpdateTimezone).toLocaleString(),
        amount: isProcessPayment ? outstandingPayment : securityDepositAmount,
        reference: "",
        status: "",
        createdAt: new Date(UpdateTimezone).toLocaleString(),
        createdBy: auth.givenname,
        syncedWithAccounting: false,
        creditCardId: id
      }, auth?.id, tenantId)
        .then(() => {
          refreshTheSummary();
          refreshThepayment();
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          setConfirmData({
            title: 'Warning',
            summary: error.response.data,
            confirmBtn: 'Ok',
            isConfirm: (callback: any) => {
              callback();
            }
          });

          setConfirmPopup(true);
          handleTenantError(error);
        });
    }
  }


  return (
    <>
      <div className="w-full">
        <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
          Return Information
        </span>

        <Divider className={`w-full ${themeStyles.divider.bg}`} />

        <form
          ref={formRef}
          onSubmit={e => e.preventDefault()}
        >
          <div className="w-full my-2">
            <div className="w-full px-2">
              <div className="grid grid-cols-2 gap-6 mb-2">
                <div>
                  <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Vehicle</span>
                  <br />
                  <span
                    className={`text-xs font-medium hover:underline text-[#0000ff] cursor-pointer`}
                    onClick={() => {
                      if (bookedVehicleData) {
                        navigate("/fleet/vehicle/editvehicles", {
                          state: bookedVehicleData?.id,
                        })
                      }
                    }}
                  >
                    {bookedVehicleData?.name || "--"}
                  </span>
                </div>

                {
                  summaryData?.status === "Completed"
                    ? (
                      <div>
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Return Location</span>
                        <br />
                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{returnLocationOptions?.find((item: any) => item?.id === returnLocations)?.locationName ?? ""}</span>
                      </div>
                    ) : (
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Return Location</label>
                        <select
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={returnLocations}
                          onChange={(e) => setReturnLocations(parseInt(e.target.value))}
                          required
                        >
                          {
                            returnLocationOptions?.map((item: any, index: number) => {
                              return <option className={`${themeStyles.main.tailwindSectionBg}`} key={index} value={item?.id}>{item?.locationName}</option>
                            })
                          }
                        </select>
                      </div>
                    )
                }
              </div>

              <div className="grid grid-cols-2 gap-6 mb-2">
                <div>
                  <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Fuel level at Pickup</span>
                  <br />
                  <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{fuelLevelAtCheckOut || 0} / 8</span>
                </div>

                <div>
                  <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Odometer at Pickup</span>
                  <br />
                  <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{odometerAtCheckOut}</span>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-6 mb-2">
                {
                  summaryData?.status === "Completed"
                    ? (
                      <div className="flex items-center justify-between gap-x-[1rem]">
                        <div>
                          <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Fuel level at Return</span>
                          <br />
                          <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{fuelLevelAtCheckIn ?? 0} / 8</span>
                        </div>

                        <div className="flex-1">
                          <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Charge fuel to client?</span>
                          <br />
                          <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{isChargeFuelToClient ? "Yes" : "No"}</span>
                        </div>
                      </div>
                    ) : (
                      <div className="flex items-center justify-between gap-x-[1rem]">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Fuel level at Return</label>
                          <select
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={fuelLevelAtCheckIn}
                            onChange={(e) =>
                              setFuelLevelAtCheckIn(parseInt(e.target.value))
                            }
                            required
                          >
                            <option className={`${themeStyles.main.tailwindSectionBg}`} value={0}>0</option>
                            <option className={`${themeStyles.main.tailwindSectionBg}`} value={1}>1</option>
                            <option className={`${themeStyles.main.tailwindSectionBg}`} value={2}>2</option>
                            <option className={`${themeStyles.main.tailwindSectionBg}`} value={3}>3</option>
                            <option className={`${themeStyles.main.tailwindSectionBg}`} value={4}>4</option>
                            <option className={`${themeStyles.main.tailwindSectionBg}`} value={5}>5</option>
                            <option className={`${themeStyles.main.tailwindSectionBg}`} value={6}>6</option>
                            <option className={`${themeStyles.main.tailwindSectionBg}`} value={7}>7</option>
                            <option className={`${themeStyles.main.tailwindSectionBg}`} value={8}>8</option>
                          </select>
                        </div>

                        <div className="flex-1">
                          <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Charge fuel to client?</label>
                          <RadioGroup
                            row
                            value={isChargeFuelToClient ? "Yes" : "No"}
                            onChange={(e) => setIsChargeFuelToClient(e.target.value === "Yes" ? true : false)}
                          >
                            <FormControlLabel
                              value="Yes"
                              control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                    '& .MuiSvgIcon-root': {
                                      fontSize: 14,
                                    },
                                  }}
                                />
                              }
                              label="Yes"
                              sx={{
                                color: themeStyles.form.labelTextColor
                              }}
                            />

                            <FormControlLabel
                              value="No"
                              control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                    '& .MuiSvgIcon-root': {
                                      fontSize: 14,
                                    },
                                  }}
                                />
                              }
                              label="No"
                              sx={{
                                color: themeStyles.form.labelTextColor
                              }}
                            />
                          </RadioGroup>
                        </div>
                      </div>
                    )
                }

                {
                  summaryData?.status === "Completed"
                    ? (
                      <div>
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Odometer at Return</span>
                        <br />
                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{odometerAtCheckIn ?? 0}</span>
                      </div>
                    ) : (
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Odometer at Return</label>
                        <input
                          type="text"
                          inputMode="numeric"
                          min={summaryData ? summaryData.odometerAtCheckOut : 0}
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={odometerAtCheckIn}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setOdometerAtCheckIn(value);
                          }}
                          onKeyDown={(e) => {
                            const allowedKeys = [
                              "Backspace",
                              "Delete",
                              "ArrowLeft",
                              "ArrowRight",
                              "Tab",
                              "Home",
                              "End",
                            ];

                            if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={(e) => {
                            const pasted = e.clipboardData.getData("text");

                            if (!/^\d+$/.test(pasted)) {
                              e.preventDefault();
                            }
                          }}
                          onDrop={(e) => e.preventDefault()}
                          autoComplete="off"
                          required
                        />
                        <br />
                        {
                          odometerShowSpan && (
                            <span className="w-full text-sm text-red-500">*Must be getter than or equal to Odometer at Pickup</span>
                          )
                        }
                      </div>
                    )
                }
              </div>

              <div className="grid grid-cols-2 gap-6 mb-2">
                {
                  summaryData?.status === "Completed"
                    ? (
                      <div>
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Return Date</span><br />
                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>
                          {
                            format(new Date(summaryData?.dateTimeCheckIn), "EEEE, MMMM dd, yyyy")
                          }
                        </span>
                      </div>
                    ) : (
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Return Date</label>
                        <CustomFormatDatePicker
                          value={returnDates}
                          onChange={setReturnDates}
                          dateFormat={preferredDateFormat}
                          minDate={
                            summaryData?.dateTimeCheckOut
                              ? moment(summaryData?.dateTimeCheckOut)?.format('YYYY-MM-DD')
                              : ""
                          }
                          required={true}
                        />
                      </div>
                    )
                }

                {
                  summaryData?.status === "Completed"
                    ? (
                      <div className="flex items-center justify-between gap-x-[1rem]">
                        <div>
                          <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Return Time</span>
                          <br />
                          <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>
                            {
                              moment(new Date(summaryData?.dateTimeCheckIn)).format("hh:mm a")
                            }

                          </span>
                        </div>

                        <div className="flex-1">
                          <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Recalculate rates on early return?</span>
                          <br />
                          <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{recalculateRatesOnEarlReturn ? "Yes" : "No"}</span>
                        </div>
                      </div>
                    ) : (
                      <div className="flex items-center justify-between gap-x-[1rem]">
                        <div className="flex flex-col gap-y-[4px] !mt-[4px]">
                          <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Return Time</label>
                          <input
                            type="time"
                            className={`w-fit px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={returnTimes}
                            onChange={(e) => setReturnTimes(e.target.value)}
                            required
                          />
                        </div>

                        <div className="flex-1">
                          <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Recalculate rates on early return?</label>
                          <RadioGroup
                            row
                            value={recalculateRatesOnEarlReturn ? "Yes" : "No"}
                            onChange={(e) => setRecalculateRatesOnEarlyReturn(e.target.value === "Yes" ? true : false)}
                          >
                            <FormControlLabel
                              value="Yes"
                              control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                    '& .MuiSvgIcon-root': {
                                      fontSize: 14,
                                    },
                                  }}
                                />
                              }
                              label="Yes"
                              sx={{
                                color: themeStyles.form.labelTextColor
                              }}
                            />

                            <FormControlLabel
                              value="No"
                              control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                    '& .MuiSvgIcon-root': {
                                      fontSize: 14,
                                    },
                                  }}
                                />
                              }
                              label="No"
                              sx={{
                                color: themeStyles.form.labelTextColor
                              }}
                            />
                          </RadioGroup>
                        </div>
                      </div>
                    )
                }
              </div>

              <div className="mt-4 w-full">
                <div className="max-w-1/2 flex flex-row items-center gap-[5px] flex-wrap">
                  {
                    filePath?.map((item: any, outerIndex: number) => (
                      <React.Fragment key={outerIndex}>
                        <img
                          src={item?.fileName}
                          width={40}
                          height={40}
                          alt="vehicleImage"
                          onClick={() => {
                            setFileIndex(outerIndex);
                            setImagePopup(true);
                          }}
                        />
                        <RemoveCircleIcon
                          className={`text-[14px] ${themeStyles.main.textSubHeadingColor} font-bold  hover:text-red-500 cursor-pointer`}
                          onClick={() => {
                            if (!isCompletedOrCancelled) {
                              setConfirmData({
                                title: 'Delete image',
                                summary: 'Are you sure you want to delete this image?',
                                confirmBtn: 'Yes',
                                isConfirm: (callback: any) => {
                                  let newFileSet: any[] = filePath?.filter(
                                    (_, index: number) => index !== outerIndex
                                  );

                                  if (filePath[outerIndex].id === 0) {
                                    setFilePath(() => newFileSet);
                                  } else {
                                    setPleaseWaitPopup(true);

                                    delete_fileUpload(filePath[outerIndex].id, auth?.id, tenantId)
                                      .then(() => {
                                        setPleaseWaitPopup(false);
                                        setFilePath(() => newFileSet);
                                        refreshTheAttachement();
                                        handleTenantError(null);
                                      })
                                      .catch((error) => {
                                        setPleaseWaitPopup(false);
                                        handleTenantError(error);
                                      });
                                  }
                                  callback();
                                }
                              });

                              setConfirmPopup(true);
                            }
                          }}
                        />
                      </React.Fragment>
                    ))
                  }
                </div>

                <div>
                  <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Images</label>
                  <input
                    type="file"
                    accept="image/*"
                    ref={inputFileRef}
                    onChangeCapture={onFileChangeCapture}
                    style={{ display: "none" }}
                  />
                  <div className="flex flex-row gap-2 mt-2">
                    <p
                      className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                      onClick={() => {
                        if (inputFileRef.current) {
                          inputFileRef.current.value = "";
                        }

                        inputFileRef.current?.click();
                      }}
                    >
                      <AddIcon className="text-[#167AC3] text-[14px] font-bold" />
                      Add Image
                    </p>

                    <p
                      className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                      onClick={() => setShowWebcam(true)}
                    >
                      <LocalSeeIcon className="text-[#167AC3] text-[14px] font-bold" />
                    </p>
                  </div>
                </div>
              </div>

              {
                summaryData?.status !== "Completed"
                && (
                  <div className="w-full mt-4 flex gap-2.5">
                    {
                      summaryData?.outstandingBalance > 0
                        ? (
                          <div>
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: "#039855",
                                fontSize: "10px"
                              }}
                              type="button"
                              onClick={handleClick2}

                            >
                              Confirm Check In

                              {
                                open2
                                  ? (
                                    <span className={`material-symbols-outlined text-white text-[25px] font-extralight`}>
                                      keyboard_arrow_up
                                    </span>
                                  ) : (
                                    <span className={`material-symbols-outlined text-white text-[25px] font-extralight`}>
                                      keyboard_arrow_down
                                    </span>
                                  )
                              }
                            </Button>

                            <Menu
                              id="basic-menu"
                              anchorEl={anchorE2}
                              open={open2}
                              onClose={handleClose2}
                              slotProps={{
                                paper: {
                                  sx: {
                                    width: "fit-content",
                                    backgroundColor: themeStyles.topBar.bg,
                                    marginTop: "4px"
                                  }
                                }
                              }}
                            >
                              <MenuItem
                                sx={{ fontSize: "12px", marginBlock: "0px" }}
                                onClick={() => {
                                  setAnchorE2(null);
                                  handleSubmit(true);
                                }}
                              >
                                <span className={`${themeStyles.topBar.tailwindTextColor} text-[16px] font-medium`}>Validate Outstanding Balance</span>
                              </MenuItem>

                              <Divider className="w-full" />

                              <MenuItem
                                sx={{ fontSize: "12px", marginBlock: "0px" }}
                                onClick={() => {
                                  setAnchorE2(null);
                                  handleSubmit(false);
                                }}
                              >
                                <span className={`${themeStyles.topBar.tailwindTextColor} text-[16px] font-medium`}>Don't Validate Outstanding Balance</span>
                              </MenuItem>
                            </Menu>
                          </div>
                        ) : (
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "#039855",
                              fontSize: "10px"
                            }}
                            type="button"
                            onClick={() => handleSubmit(false)}
                          >
                            Confirm Check In
                          </Button>
                        )
                    }

                    <Button variant="contained"
                      sx={{
                        backgroundColor: "#4F959D",
                        fontSize: "10px"
                      }}
                      type="button"
                      onClick={reCalculateTheRate}
                    >
                      Recalculate Changes
                    </Button>
                  </div>
                )
              }
            </div>
          </div>
        </form>

        <span className={`text-[14px] font-semibold inline-block my-2 ${themeStyles.main.textHeadingColor}`}>
          Payments
        </span>

        <Divider className={`w-full ${themeStyles.divider.bg}`} />

        <div className="w-full my-3">
          <table className="min-w-full">
            <tbody className="text-left">
              <tr className={`border-b ${themeStyles.main.borderColor}`}>
                <th className={`w-[5%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>#</th>
                <th className={`w-[10%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Payment Type</th>
                <th className={`w-[12%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Payment Method</th>
                <th className={`w-[10%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Date</th>
                <th className={`w-[10%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Amount</th>
                <th className={`w-[10%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Reference</th>
                <th className={`w-[10%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Payment Status</th>
                <th className={`w-[12%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Created By</th>
                <th className={`w-[10%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Created at</th>
                <th className={`w-[10%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Synced with Accounting?</th>
              </tr>

              {
                allPaymentList?.map((item: any, index: number) => {
                  return (
                    <tr key={index} className={`border-b ${themeStyles.main.borderColor}`}>
                      <td className="py-2 w-[8%]">
                        <span
                          className={`text-xs font-medium ${(permissions?.disabledrefund || auth?.roles?.toLowerCase()?.trim() === "admin") ? "text-blue-500 underline cursor-pointer" : "cursor-default"} ${themeStyles.main.textHeadingColor}`}
                          onClick={() => {
                            if (permissions?.disabledrefund || auth?.roles?.toLowerCase()?.trim() === "admin") {
                              setOpenPaymentDetailsPopup(true);
                              setParticularPaymentDetails(item);
                            }
                          }}
                        >
                          {item?.id}
                        </span>
                      </td>

                      <td className="py-2 w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.paymentType}</span>
                      </td>

                      <td className="py-2 w-[12%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.paymentMethod}</span>
                      </td>

                      <td className="w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                          {
                            item?.dateofPayment
                              ? moment(
                                new Date(
                                  item?.dateofPayment
                                    ?.replaceAll("-", "/")
                                    ?.split("T")[0]
                                )
                              ).format(dateFormat)
                              : ""
                          }
                        </span>
                      </td>

                      <td className="py-2 w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>${parseFloat(item?.amount)?.toFixed(2)}</span>
                      </td>

                      <td className="py-2 w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.reference}</span>
                      </td>

                      <td className="py-2 w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.status}</span>
                      </td>

                      <td className="py-2 w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.createdBy}</span>
                      </td>

                      <td className="py-2 w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                          {
                            item?.createdAt
                              ? moment(new Date(item.createdAt)).format(dateFormat + " hh:mm a")
                              : ""
                          }
                        </span>
                      </td>

                      <td className="py-2 w-[10%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}> {item?.syncedWithAccounting ? "Yes" : "No"}</span>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>

        <div className="w-full flex gap-2.5 mt-4">
          {
            (
              summaryData?.outstandingBalance > 0
              || (
                !isSecurityDepositedPaid
                && securityDepositAmount > 0
              )
            ) && (
              <Button variant="contained"
                sx={{
                  backgroundColor: colorConfigs.btn.main.bg,
                  fontSize: "10px"
                }}
                onClick={() => {
                  if (!isCompletedOrCancelled)
                    if (summaryData?.outstandingBalance > 0 || (!isSecurityDepositedPaid && securityDepositAmount > 0)) {
                      setOfflinePaymentPopup(true)
                    } else {
                      setConfirmData({
                        title: 'Warning',
                        summary: 'You do not have any Outstanding Balance',
                        confirmBtn: 'Ok',
                        isConfirm: (callback: any) => {
                          callback();
                        }
                      });

                      setConfirmPopup(true);
                    }
                }}
              >
                Add Offline Payment
              </Button>
            )
          }

          {
            creditCardList?.length > 0 && (
              <>
                {
                  (
                    summaryData?.outstandingBalance > 0
                  ) && (
                    <>
                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.main.bg,
                          fontSize: "10px"
                        }}
                        onClick={handleClick}
                      >
                        Pay ${parseFloat(summaryData?.outstandingBalance)?.toFixed(2)} with Authorize
                        {
                          open
                            ? (<span className={`material-symbols-outlined text-white text-[20px] font-extralight`}>
                              keyboard_arrow_up
                            </span>
                            ) : (<span className={`material-symbols-outlined text-white text-[20px] font-extralight`}>
                              keyboard_arrow_down
                            </span>
                            )
                        }
                      </Button>

                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        slotProps={{
                          paper: {
                            sx: {
                              width: 230,
                              backgroundColor: themeStyles.topBar.bg
                            }
                          }
                        }}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                      >
                        {
                          creditCardList?.map((item: any, i: number) => ([
                            <MenuItem
                              key={`${i}-Item`}
                              sx={{ fontSize: "12px", marginBlock: "0px" }}
                              onClick={() => {
                                if (!isCompletedOrCancelled) {
                                  if (summaryData?.outstandingBalance > 0) {
                                    setConfirmData({
                                      title: 'Payment',
                                      summary: 'Are you sure you want to pay?',
                                      confirmBtn: 'Yes',
                                      isConfirm: (callback: any) => {
                                        handleAuthorize(true, item?.id);
                                        callback();
                                      }
                                    });

                                    setConfirmPopup(true);

                                    handleClose();
                                  } else {
                                    setConfirmData({
                                      title: 'Warning',
                                      summary: 'You do not have any Outstanding Balance',
                                      confirmBtn: 'Ok',
                                      isConfirm: (callback: any) => {
                                        callback();
                                      }
                                    });

                                    setConfirmPopup(true);
                                  }
                                }
                              }}
                            >
                              <span className={`${themeStyles.topBar.tailwindTextColor} font-medium`}>{item?.cardholderName + " - " + item?.creditCardNumber?.substr(-4)}</span>
                            </MenuItem>,
                            <Divider key={`${i}-Divider`} className="w-full" />
                          ]))
                        }
                      </Menu>
                    </>
                  )
                }
              </>
            )
          }

          {
            (!isSecurityDepositedPaid && securityDepositAmount > 0)
            && (
              <>
                <Button variant="contained"
                  sx={{
                    backgroundColor: colorConfigs.btn.main.bg,
                    fontSize: "10px"
                  }}
                  onClick={shandleClick}
                >
                  Authorize ${securityDepositAmount?.toFixed(2)} with Authorize
                  {
                    sopen
                      ? (<span className={`material-symbols-outlined text-white text-[20px] font-extralight`}>
                        keyboard_arrow_up
                      </span>
                      ) : (
                        <span className={`material-symbols-outlined text-white text-[20px] font-extralight`}>
                          keyboard_arrow_down
                        </span>
                      )
                  }
                </Button>

                <Menu
                  id="basic-menu"
                  anchorEl={sanchorEl}
                  open={sopen}
                  onClose={shandleClose}
                  slotProps={{
                    paper: {
                      sx: {
                        width: 230,
                        backgroundColor: themeStyles.topBar.bg
                      }
                    }
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  {
                    creditCardList?.map((item: any, j: number) => ([
                      <MenuItem
                        key={`${j}-Item`}
                        sx={{ fontSize: "12px", marginBlock: "0px" }}
                        onClick={() => {
                          if (!isCompletedOrCancelled) {
                            if (securityDepositAmount > 0) {
                              setConfirmData({
                                title: 'Security Deposit',
                                summary: 'Are you sure you want to pay?',
                                confirmBtn: 'Yes',
                                isConfirm: (callback: any) => {
                                  handleAuthorize(false, item?.id);
                                  callback();
                                }
                              });

                              shandleClose();
                            } else {
                              setConfirmData({
                                title: 'Warning',
                                summary: 'You do not have Security Deposit Amount to Pay',
                                confirmBtn: 'Ok',
                                isConfirm: (callback: any) => {
                                  callback();
                                }
                              });

                              setConfirmPopup(true);
                            }
                          }
                        }}>
                        <span className={`${themeStyles.topBar.tailwindTextColor} font-medium`}>{item?.cardholderName + " - " + item?.creditCardNumber?.substr(-4)}</span>
                      </MenuItem>,
                      <Divider key={`${j}-Divider`} className="w-full" />
                    ]))
                  }
                </Menu>
              </>
            )}
        </div>

        <div className="w-full mt-2">
          {
            (
              (permissions?.disabledrefund || auth?.roles?.toLowerCase()?.trim() === "admin")
              && !isSecurityDepositedRefunded
              && isSecurityDepositedPaid
            ) && (
              <Button variant="contained"
                sx={{
                  backgroundColor: "#007074",
                  fontSize: "10px"
                }}
                onClick={() => {
                  if (summaryData?.outstandingBalance >= summaryData?.securityDepositAmountPaid) {
                    setConfirmData({
                      title: 'Warning',
                      summary: 'Your outstanding balance is greater than security deposit',
                      confirmBtn: 'Ok',
                      isConfirm: (callback: any) => {
                        callback();
                      }
                    });

                    setConfirmPopup(true);
                  } else {
                    setRefundSecurityDepositPopup(true)
                  }
                }}
              >
                Refund Security Deposit
              </Button>
            )
          }
        </div>

        <div className="w-full flex gap-2.5 mt-2">
          {
            (
              summaryData?.outstandingBalance > 0
            ) && (
              <Button variant="contained"
                sx={{
                  backgroundColor: "#1DCD9F",
                  fontSize: "10px"
                }}
                onClick={() => {
                  if (!isCompletedOrCancelled) {
                    if (summaryData?.outstandingBalance > 0) {
                      setIsProcessPayment(true);
                      setProcessPaymentBox(true);
                    } else {
                      setConfirmData({
                        title: 'Warning',
                        summary: 'You do not have any Outstanding Balance',
                        confirmBtn: 'Ok',
                        isConfirm: (callback: any) => {
                          callback();
                        }
                      });

                      setConfirmPopup(true);
                    }
                  }
                }}
              >
                Process Payment
              </Button>
            )
          }

          {
            (
              summaryData?.outstandingBalance > 0
            ) && (
              <Button variant="contained"
                sx={{
                  backgroundColor: "#3E3F5B",
                  fontSize: "10px"
                }}
                onClick={() => {
                  if (!isCompletedOrCancelled) {
                    if (summaryData?.outstandingBalance > 0) {
                      setIsPaymentRequestType(true);
                      setOpenPaymentRequestPopup(true)
                    } else {
                      setConfirmData({
                        title: 'Warning',
                        summary: 'You do not have any Outstanding Balance',
                        confirmBtn: 'Ok',
                        isConfirm: (callback: any) => {
                          callback();
                        }
                      });

                      setConfirmPopup(true);
                    }
                  }
                }}
              >
                Request Payment
              </Button>
            )
          }
        </div>

        {
          (
            summaryData?.status?.trim()?.toLowerCase() !== "reopen"
          ) && (
            <div className="w-full mt-2">
              <Button variant="contained"
                sx={{
                  backgroundColor: "#DE6F0D",
                  fontSize: "10px"
                }}
                onClick={reopenedTheBooking}
              >
                Re-open Reservation
              </Button>
            </div>
          )
        }
      </div>

      {allPaymentRequestList?.length > 0 && (
        <div className="mb-[2.5rem]">
          <span className={`text-[14px] font-semibold inline-block mb-2 mt-10 ${themeStyles.main.textHeadingColor}`}>
            Payment Requests
          </span>

          <div
            className="overflow-x-auto"
            style={{
              scrollbarWidth: 'thin',
              WebkitOverflowScrolling: 'touch',
            }}
          >
            <div className="inline-block min-w-max">
              <Divider className={`w-full ${themeStyles.divider.bg}`} />

              <table className="min-w-full table-auto">
                <tbody className="text-left">
                  <tr className={`border-b ${themeStyles.main.borderColor}`}>
                    <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>#</th>
                    <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Request Type</th>
                    <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Amount</th>
                    <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Email</th>
                    <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Status</th>
                    <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Payment Link</th>
                    <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Due Date</th>
                    <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Created At</th>
                    <th className={`text-[12px] font-semibold whitespace-nowrap px-4 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Created By</th>
                  </tr>

                  {allPaymentRequestList?.map((item: any, index: number) => {
                    const statusColor = paymentRequestStatusColorCode?.find((color: any) => color?.label === item?.status?.trim()?.toLowerCase()) || {
                      colorBg: "#000000",
                      colorText: "#000000"
                    };

                    return (
                      <tr key={index} className={`border-b ${themeStyles.main.borderColor}`}>
                        <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium text-blue-500 underline cursor-pointer ${themeStyles.main.textHeadingColor}`}
                          onClick={() => {
                            setOpenPaymentRequestDetailsPopup(true);
                            setPaymentRequestDetails(item);
                          }}>
                          {item?.id}
                        </td>

                        <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                          {item?.requestType}
                        </td>

                        <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                          ${parseFloat(item?.amount)?.toFixed(2)}
                        </td>

                        <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                          {item?.email}
                        </td>

                        <td className="px-4 py-2 whitespace-nowrap text-xs font-medium">
                          <span className={`px-[10px] py-[2px] rounded-xl border ${themeStyles.main.borderColor} ${statusColor.colorText} ${statusColor.colorBg}`}>
                            {item?.status}
                          </span>
                        </td>

                        <td className="px-4 py-2 whitespace-nowrap text-xs font-medium text-blue-500 cursor-pointer hover:underline"
                          onClick={() => {
                            if (showCopyPopup) {
                              setShowCopyPopup(false);
                            }
                            navigator.clipboard.writeText(item?.paymentLink);
                            setShowCopyPopup(true);
                            setTimeout(() => setShowCopyPopup(false), 500);
                          }}
                        >
                          Click here to copy
                        </td>

                        <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                          {item?.dueDate
                            ? moment(
                              new Date(item.dueDate.replaceAll("-", "/").split("T")[0])
                            ).format(dateFormat)
                            : ""}
                        </td>

                        <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                          {item?.createdAt
                            ? moment(new Date(item.createdAt)).format(dateFormat + " hh:mm a")
                            : ""}
                        </td>

                        <td className={`px-4 py-2 whitespace-nowrap text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                          {item?.createdBy}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      <Dialog
        open={showWebcam}
        maxWidth="md"
        fullScreen={false}
        sx={{
          '& .MuiDialog-paper': {
            maxWidth: '500px',
            width: '100%',
            borderRadius: '16px',
          },
        }}
      >
        <div className={`px-[10px] py-[5px] h-full ${themeStyles.main.tailwindSectionBg}`}>
          <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
            <div className="w-full mt-2">
              <div className={`w-full`}>
                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                  <div className="flex items-center gap-1.5">
                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>WebCam</h2>
                  </div>
                </div>

                <div className="mt-2 p-2">
                  <div className="w-full">
                    <Webcam
                      width={500}
                      height={320}
                      ref={webRef}
                      screenshotFormat="image/png"
                      audio={false}
                    />

                    <div className="flex gap-4 mt-6">
                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => {
                          if (!isCompletedOrCancelled)
                            setShowWebcam(false)
                        }}
                      >
                        Cancel
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.main.bg
                        }}
                        onClick={() => {
                          if (webRef.current !== null) {
                            //@ts-ignore
                            const imageSrc = webRef.current.getScreenshot();

                            handleCapture(imageSrc, `${baseURL}reservationFile/upload`, tenantId, (imageFilePath: string) => {
                              if (imageFilePath) {
                                let files: any[] = [];

                                if (summaryData?.isVehicleReplaced) {
                                  files.push({
                                    attributeName: "Reservation",
                                    attributeId: reservationId,
                                    fileName: imageFilePath,
                                    tabName: `Checkin-VehicleReplacement-${summaryData?.id}`,
                                    userId: auth?.id ?? 0,
                                    createdDate: new Date(UpdateTimezone).toLocaleString()
                                  });
                                } else {
                                  files.push({
                                    attributeName: "Reservation",
                                    attributeId: reservationId,
                                    fileName: imageFilePath,
                                    tabName: "Checkin",
                                    userId: auth?.id ?? 0,
                                    createdDate: new Date(UpdateTimezone).toLocaleString()
                                  });
                                }

                                uploadTheFiles(files);
                              }
                            })
                            setShowWebcam(false);
                          }
                        }}
                      >
                        Capture an Image
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      <CustomImagePopup
        showPopup={imagePopup}
        handlePopup={() => setImagePopup(false)}
        filePath={filePath}
        fileIndex={fileIndex}
        setFileIndex={setFileIndex}
        imageBaseUrlPath="reservationFile"
        updateFile={updateFile}
      />

      <ProcessPaymentBox
        open={processPaymentBox}
        onClose={() => {
          setProcessPaymentBox(false);
          setIsProcessPayment(true);
        }}
        isCompletedOrCancelled={isCompletedOrCancelled}
        setPleaseWait={setPleaseWaitPopup}
        reservationId={reservationId}
        summaryData={summaryData}
        formattedCreatedAt={formattedCreatedAt}
        refreshTheSummary={refreshTheSummary}
        refreshThepayment={refreshThepayment}
        isProcessPayment={isProcessPayment}
        securityDepositAmount={securityDepositAmount}
      />

      <AddOfflinePayment
        open={offlinePaymentPopup}
        onClose={() => setOfflinePaymentPopup(false)}
        isCompletedOrCancelled={isCompletedOrCancelled}
        setPleaseWait={setPleaseWaitPopup}
        reservationId={reservationId}
        summaryData={summaryData}
        formattedCreatedAt={formattedCreatedAt}
        refreshTheSummary={refreshTheSummary}
        refreshThepayment={refreshThepayment}
        preferredDateFormat={preferredDateFormat}
        securityDepositAmount={securityDepositAmount}
      />

      {
        (permissions?.disabledrefund || auth?.roles?.toLowerCase()?.trim() === "admin")
        && (
          <PaymentDetailsPopup
            open={openPaymentDetailsPopup}
            onClose={() => {
              setParticularPaymentDetails(null);
              setOpenPaymentDetailsPopup(false);
            }}
            paymentDetails={particularPaymentDetails}
            creditCardList={creditCardList}
            setPleaseWait={setPleaseWaitPopup}
            formattedCreatedAt={formattedCreatedAt}
            isCompletedOrCancelled={isCompletedOrCancelled}
            isSecurityDepositedRefunded={isSecurityDepositedRefunded}
            reservationId={reservationId}
            summaryData={summaryData}
            refreshTheReservation={() => {
              refreshTheSummary();
              refreshThepayment();
              refreshThRefund();
            }}
            refundList={refundList}
          />
        )
      }

      <PaymentRequest
        open={openPaymentRequestPopup}
        onClose={() => setOpenPaymentRequestPopup(false)}
        isCompletedOrCancelled={isCompletedOrCancelled}
        setPleaseWait={setPleaseWaitPopup}
        reservationId={reservationId}
        summaryData={summaryData}
        preferredDateFormat={preferredDateFormat}
        formattedCreatedAt={formattedCreatedAt}
        isPaymentRequestType={isPaymentRequestType}
        refreshThePaymentRequest={refreshThePaymentRequest}
      />

      <PaymentRequestDetails
        open={openPaymentRequestDetailsPopup}
        onClose={() => setOpenPaymentRequestDetailsPopup(false)}
        isCompletedOrCancelled={isCompletedOrCancelled}
        setPleaseWait={setPleaseWaitPopup}
        paymentRequestDetails={paymentRequestDetails}
        refreshThePaymentRequest={refreshThePaymentRequest}
      />

      {
        (permissions?.disabledrefund || auth?.roles?.toLowerCase()?.trim() === "admin")
        && !isSecurityDepositedRefunded
        && (
          <RefundSecurityDepositPopup
            open={refundSecurityDepositPopup}
            onClose={() => setRefundSecurityDepositPopup(false)}
            setPleaseWait={setPleaseWaitPopup}
            reservationId={reservationId}
            data={summaryData}
            formattedCreatedAt={formattedCreatedAt}
            refreshTheSummary={() => {
              refreshTheSummary();
              refreshThRefund();
            }}
            refundList={refundList}
            allPaymentList={allPaymentList}
          />
        )
      }

      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={showCopyPopup}
        autoHideDuration={1000}
        onClose={handleClose}
      >
        <Alert
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Link copied
        </Alert>
      </Snackbar>
    </>
  )
}